var _path, _circle, _path2, _ellipse, _path3, _ellipse2, _path4, _path5, _path6, _ellipse3, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaiting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 430.914,
    height: 559.71,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M304.755 154.54q0 4.784-.31 9.49a143.754 143.754 0 0 1-13.47 52.19c-.06.14-.13.27-.19.4-.36.76-.73 1.52-1.11 2.27a142.039 142.039 0 0 1-7.65 13.5 144.462 144.462 0 0 1-118.56 66.72l1.43 82.24 18.65-9.82 3.33 6.33-21.84 11.5 2.67 152.74.03 2.04-14.42 1.21.03-.05 4.54-246.18a144.175 144.175 0 0 1-102-44.38c-.91-.94-1.81-1.91-2.69-2.87-.04-.04-.07-.08-.1-.11A144.768 144.768 0 0 1 26.755 211c.14.16.29.31.43.47a144.642 144.642 0 0 1 68.58-186.38c.5-.25 1.01-.49 1.51-.74a144.752 144.752 0 0 1 187.53 56.93c.88 1.48 1.73 2.99 2.55 4.51a143.852 143.852 0 0 1 17.4 68.75Z",
    fill: "#e5e5e5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 198.285,
    cy: 502.618,
    r: 43.067,
    fill: "#2f2e41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M210.603 532.223h38.584v13.084h-38.584z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 249.459,
    cy: 534.403,
    rx: 4.089,
    ry: 10.903,
    fill: "#2f2e41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M201.603 531.223h38.584v13.084h-38.584z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.459,
    cy: 533.403,
    rx: 4.089,
    ry: 10.903,
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M156.508 462.567c-3.477-15.574 7.639-31.31 24.829-35.149s33.944 5.675 37.421 21.25-7.915 21.317-25.104 25.155-33.668 4.318-37.146-11.256Z",
    fill: "#65ac67"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M214.837 500.166a10.751 10.751 0 0 1-10.34-7.123 1 1 0 0 1 1.897-.637c1.514 4.508 6.698 6.865 11.554 5.254a9.608 9.608 0 0 0 5.573-4.748 8.232 8.232 0 0 0 .485-6.338 1 1 0 0 1 1.896-.637 10.217 10.217 0 0 1-.592 7.869 11.624 11.624 0 0 1-6.732 5.752 11.88 11.88 0 0 1-3.74.608Zm19.185 5.854a9.572 9.572 0 1 1-17.046 8.717l-.008-.017c-2.403-4.71.917-7.632 5.627-10.035s9.024-3.375 11.427 1.334Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M387.733 546.074h-381a1 1 0 0 1 0-2h381a1 1 0 0 1 0 2Z",
    fill: "#3f3d56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 567.226,
    cy: 706.642,
    rx: 7.501,
    ry: 23.892,
    transform: "rotate(-14.461 -295.58 2137.035)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M260.966 451.278H244.58a.773.773 0 0 1-.519-1.345l14.9-13.495h-13.766a.773.773 0 0 1 0-1.545h15.77a.773.773 0 0 1 .52 1.345l-14.9 13.495h14.38a.773.773 0 1 1 0 1.545Zm20.864-23.955h-16.386a.773.773 0 0 1-.519-1.345l14.9-13.495H266.06a.773.773 0 0 1 0-1.545h15.77a.773.773 0 0 1 .52 1.345l-14.9 13.495h14.38a.773.773 0 1 1 0 1.545Zm-9.273-26.273h-16.386a.773.773 0 0 1-.518-1.345l14.9-13.495h-13.767a.773.773 0 0 1 0-1.546h15.771a.773.773 0 0 1 .519 1.346l-14.9 13.495h14.381a.773.773 0 0 1 0 1.545Z",
    fill: "#cbcbcb"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m386.12 177.377 12.794-10.234c-9.94-1.096-14.024 4.325-15.695 8.615-7.766-3.224-16.219 1.002-16.219 1.002l25.6 9.293a19.372 19.372 0 0 0-6.48-8.676Zm-367-167L31.913.143C21.974-.953 17.89 4.468 16.219 8.758 8.453 5.534 0 9.76 0 9.76l25.6 9.293a19.372 19.372 0 0 0-6.48-8.676Zm399 35 12.794-10.234c-9.94-1.096-14.024 4.325-15.695 8.615C407.453 40.534 399 44.76 399 44.76l25.6 9.293a19.372 19.372 0 0 0-6.48-8.676Z",
    fill: "#3f3d56"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiting);
export default __webpack_public_path__ + "static/media/waiting.92121d46893cd88069a2fa9174c60df5.svg";
export { ForwardRef as ReactComponent };